import { IItemPreviewProps } from '@aytm/app/swidget/base/questions/Ecommerce/types.ts'
import style from './style.module.scss'
import eStyles from '../ecommerce.module.scss'
import React from 'react'
import { Button } from 'primereact/button'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale.ts'
import { formatPriceWithLocale } from '../../utils/formatPriceWithLocale.ts'
import { getSmallAssetPath } from '@aytm/lib/common/assets.ts'

const ItemPreview = ({ schema, width, questionSchema, available, onAddToCart, onItemSelect }: IItemPreviewProps) => {
  const { t, languageTag } = useSurveyLocale()

  return (
    <div
      className={`${style.ecommerceItemPreview} ${schema.available ? style.available : ''}`}
      onClick={schema.available ? onItemSelect : null}
    >
      <div className={style.ecommerceItemImageContainer}>
        <img
          data-testid="SW-SH-ECommerceImage"
          className={style.ecommerceItemImage}
          alt={schema.image?.alt_text || t('questions', 'img', 'noAlt')}
          src={
            schema.image && schema.image.original_url
              ? `${getSmallAssetPath(schema.image)}`
              : '/images/widget/sh/no-image.jpg'
          }
        ></img>
      </div>
      {schema.available ? (
        <>
          <div
            className={style.header}
            data-testid="SW-SH-Item-Header"
            dangerouslySetInnerHTML={{ __html: schema.text }}
          />
          {schema.price > schema.discounted_price && schema.discounted_price && !questionSchema.hide_price ? (
            <div
              className={eStyles.discountedPrice}
              data-testid="SW-SH-Item-DPrice"
              dangerouslySetInnerHTML={{
                __html: formatPriceWithLocale(schema.price, questionSchema.price_mask, languageTag, true)
              }}
            />
          ) : (
            ''
          )}
          {!questionSchema.hide_price && (
            <div
              className={eStyles.price}
              data-testid="SW-SH-Item-Price"
              dangerouslySetInnerHTML={{
                __html: formatPriceWithLocale(
                  schema.discounted_price ? schema.discounted_price : schema.price,
                  questionSchema.price_mask,
                  languageTag,
                  true
                )
              }}
            />
          )}
          <Button
            label={t('questions', 'ec', 'addToCart')}
            className={`${style.button} ${width < 140 ? style.small : ''}`}
            onClick={event => {
              event?.stopPropagation()
              onAddToCart()
            }}
            data-testid="SW-SH-Item-AddButton"
            disabled={!available}
          />
        </>
      ) : (
        ''
      )}
    </div>
  )
}

export default ItemPreview
